"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var tableLayoutConfig = {
  fixed: {
    layout: 'fixed',
    width: {
      xxs: 'calc(6rem * 1.6)',
      m: 'calc(8rem * 1.6)'
    },
    minWidth: {
      xxs: 'auto',
      m: 'auto'
    },
    columnWrap: 'normal'
  },
  auto: {
    layout: 'auto',
    width: {
      xxs: 'auto',
      m: 'auto'
    },
    minWidth: {
      xxs: 'calc(6rem * 1.6)',
      m: 'calc(8rem * 1.6)'
    },
    columnWrap: 'normal'
  },
  expandColumnHeaders: {
    layout: 'auto',
    width: {
      xxs: 'auto',
      m: 'auto'
    },
    minWidth: {
      xxs: 'calc(6rem * 1.6)',
      m: 'calc(8rem * 1.6)'
    },
    columnWrap: 'nowrap'
  }
};
var _default = exports["default"] = tableLayoutConfig;